import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { logger } from '@logger'
import { INTERNAL_CONSTANTS } from '@constants/internalConstants'
import { startSocket, stopSocket } from '@sockets'

const MODULE = 'Socket Connection Hook'

/**
 * Opens the single shared socket once the player session is ready.
 *
 * Gated on `authenticationStatus === SUCCEEDED` because the handshake needs the
 * `accessToken` (and `gameCode`/`gameMode`) minted by the GraphQL `init` call.
 * Mount this once, at bootstrap, alongside `useGameBootstrap`.
 */
export const useSocketConnection = () => {
  const authenticationStatus = useSelector((state) => state.session.authenticationStatus)
  const { accessToken, gameCode, gameMode } = useSelector((state) => state.session.details)

  useEffect(() => {
    if (authenticationStatus !== INTERNAL_CONSTANTS.AUTHENTICATION_STATUS.SUCCEEDED) return

    if (!accessToken || !gameCode || gameMode == null) {
      logger.error(MODULE, 'Missing session details — cannot open socket', {
        hasAccessToken: Boolean(accessToken),
        gameCode,
        gameMode,
      })
      return
    }

    startSocket({ accessToken, gameCode, gameMode })

    return () => stopSocket()
  }, [authenticationStatus, accessToken, gameCode, gameMode])
}
